/**
 * Display-label map for comparison columns.
 *
 * The public API field names (cyCloud / awsGovCloud / azureGov / diyFederal)
 * are the wire format and DO NOT change. UI components import this map and
 * render the display label per the brand-hierarchy correction:
 *
 *   - cyCloud      → "CyCloud · operated by CyLogic"
 *   - diyFederal   → "Build-your-own federal cloud"
 *
 * Keep this file the single source of truth for these strings. Components
 * MUST NOT inline the display labels.
 */

export const COMPARISON_LABELS = {
  cyCloud: 'CyCloud · operated by CyLogic',
  awsGovCloud: 'AWS GovCloud',
  azureGov: 'Azure Government',
  diyFederal: 'Build-your-own federal cloud',
} as const

export const COMPARISON_LABELS_SHORT = {
  cyCloud: 'CyCloud',
  awsGovCloud: 'AWS GovCloud',
  azureGov: 'Azure Gov',
  diyFederal: 'Build-your-own',
} as const

export type ComparisonKey = keyof typeof COMPARISON_LABELS
